/* ============================================================
 * LUMERA — ATC → DIRECT CHECKOUT (fast path)
 *
 * Loaded from snippets/meta-tags.liquid on product pages only.
 * Binds on `window` in the CAPTURE phase so it runs before (and
 * cancels) the older document-level handler in assets/custom.js.
 *
 * How it is fast:
 *  1. WARM-UP — on pointerdown/touchstart a preconnect hint opens
 *     the TCP/TLS handshake to the checkout origin. This makes NO
 *     cart mutation and fires NO trackable request; /cart/add.js is
 *     never called before the click.
 *  2. INSTANT FEEDBACK — the button flips to a spinner
 *     synchronously on click. Shopify's own checkout page takes
 *     ~2s to render and that is not something theme code can
 *     change, so the job here is to never look frozen.
 *  3. NO CART DRAWER — goes straight to /checkout.
 *
 * The cart-add (POST /cart/add.js) runs ONLY on the real click /
 * activation, immediately before navigating to /checkout, so a
 * shopper can never be charged for an item they merely touched.
 * ============================================================ */
(function () {
  var ATC_SELECTOR = [
    '[name="add"]',
    '[data-action="add-to-cart"]',
    '.product-form__submit',
    '.shop-add-to-cart-button',
    '.lm-cta',
    '.lm-sticky-cta',
    '[data-sadd]'
  ].join(', ');

  var busy = false;
  var restore = null;
  var warmed = false;

  /* ---------- helpers ---------- */

  function injectCss() {
    if (document.getElementById('lm-fc-css')) return;
    var s = document.createElement('style');
    s.id = 'lm-fc-css';
    s.textContent =
      '@keyframes lmfcspin{to{transform:rotate(360deg)}}' +
      '.lm-fc-spin{display:inline-block;width:1em;height:1em;margin-right:.55em;' +
      'vertical-align:-.12em;border:2px solid currentColor;border-right-color:transparent;' +
      'border-radius:50%;animation:lmfcspin .6s linear infinite}' +
      '.lm-fc-veil{position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483647;' +
      'background:transparent;cursor:progress}';
    (document.head || document.documentElement).appendChild(s);
  }

  function atcFrom(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest(ATC_SELECTOR);
    if (!btn) return null;
    if (btn.closest('#CartDrawer, .cart-drawer, .gb-get-main-freq-pro')) return null;
    return btn;
  }

  function getProductForm(btn) {
    var form = btn.closest('form[action*="/cart/add"]');
    if (form && form.querySelector('[name="id"]')) return form;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('[name="id"]')) return forms[i];
    }
    return null;
  }

  function addToCart(form) {
    return fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) { return r.ok; });
  }

  function formPost(form) {
    var rt = form.querySelector('input[name="return_to"]');
    if (!rt) {
      rt = document.createElement('input');
      rt.type = 'hidden';
      rt.name = 'return_to';
      form.appendChild(rt);
    }
    rt.value = '/checkout';
    HTMLFormElement.prototype.submit.call(form);
  }

  function showBusy(btn) {
    injectCss();
    var veil = document.createElement('div');
    veil.className = 'lm-fc-veil';
    document.body.appendChild(veil);
    var label = btn.querySelector('.button-text') || btn;
    restore = { el: label, html: label.innerHTML, btn: btn };
    label.innerHTML = '<span class="lm-fc-spin"></span>SECURING YOUR ORDER…';
    btn.style.pointerEvents = 'none';
  }

  function clearBusy() {
    busy = false;
    var veils = document.querySelectorAll('.lm-fc-veil');
    for (var i = 0; i < veils.length; i++) {
      if (veils[i].parentNode) veils[i].parentNode.removeChild(veils[i]);
    }
    if (restore) {
      restore.el.innerHTML = restore.html;
      restore.btn.style.pointerEvents = '';
      restore = null;
    }
  }

  /* ---------- 1. warm-up on press (NO cart mutation) ---------- */

  function onPress(e) {
    if (e.button !== undefined && e.button !== 0) return;
    var btn = atcFrom(e.target);
    if (!btn) return;
    if (warmed) return;
    warmed = true;
    // Harmless connection warm-up only: open the TCP/TLS handshake to
    // the checkout origin so the click-time navigation is faster. This
    // makes NO cart mutation and fires NO trackable request. Under no
    // circumstances is /cart/add.js called before the click.
    try {
      var l = document.createElement('link');
      l.rel = 'preconnect';
      l.href = window.location.origin;
      (document.head || document.documentElement).appendChild(l);
    } catch (err) {}
  }

  window.addEventListener('pointerdown', onPress, true);
  window.addEventListener('touchstart', onPress, true);

  /* ---------- 2. intercept the click — cart-add happens here only ---------- */

  window.addEventListener('click', function (e) {
    var btn = atcFrom(e.target);
    if (!btn) return;
    var form = getProductForm(btn);
    if (!form) return;
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    if (busy) return;
    busy = true;
    showBusy(btn);

    // Add to cart ONLY now, on the real activation, then go straight to
    // /checkout. If the add fails, fall back to a normal server-side form
    // submit so the shopper is never stranded.
    addToCart(form).then(function (ok) {
      if (ok) { window.location.href = '/checkout'; }
      else { formPost(form); }
    }).catch(function () {
      formPost(form);
    });
  }, true);

  window.addEventListener('pageshow', clearBusy);
})();
